import React from 'react';
import { IMAGES } from '../data/site';
import { SectionCta } from './SectionCta';
export function AboutAuthor() {
  return <section className="w-full bg-navy-deep px-5 py-14 sm:px-6 sm:py-20" data-id="element-2" data-mp="1e95yvink6p19">
      <div className="mx-auto max-w-4xl" data-id="element-3" data-mp="1sz4sd8465cae">
        <div className="grid items-center gap-7 md:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] md:gap-10" data-id="element-4" data-mp="1sy212z2xp7ty">
          <div className="mx-auto w-full max-w-xs md:max-w-none" data-id="element-5" data-mp="1o1v5o085zeq9">
            <img src={IMAGES.author} alt="Dr. Karito, creator of Menopause Decision Desk™" className="w-full rounded-2xl border border-gold/30 object-cover" width={945} height={1680} data-id="element-6" data-mp="10az6gi1dph8z" />
          </div>

          <div data-id="element-7" data-mp="1590yvtkp2sx4">
            <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-gold-light" data-id="element-8" data-mp="158hjokmfiims">About Dr. Karito</p>
            <h2 className="mt-3 font-serif text-[28px] font-bold leading-[1.12] text-cream sm:text-4xl" data-id="element-9" data-mp="2kogdeqvauc3i">
              Making menopause decisions simpler
            </h2>
            <div className="mt-5 space-y-4 text-[15.5px] leading-relaxed text-cream/75" data-id="element-10" data-mp="2wiytsri8d4bn">
              <p data-id="element-11" data-mp="31ibsc9igrzu2">
                Dr. Karito created Menopause Decision Desk™ to solve a common challenge in menopause care:
                too much information, spread across too many sources, and too little time to find what
                matters.
              </p>
              <p className="font-serif text-[18px] font-semibold italic leading-snug text-gold-light sm:text-xl" data-id="element-12" data-mp="2dtita46jpbv8">
                Her approach is simple: turn complex clinical evidence into clear, practical decision
                pathways.
              </p>
              <p data-id="element-13" data-mp="2msnrf9e7336v">
                The result is a system designed to help healthcare professionals assess, stratify, decide,
                adjust, and follow up with greater structure during real-world consultations.
              </p>
              <p className="text-cream/60" data-id="element-14" data-mp="1z4mmsbk506wq">
                The goal isn’t to study more. It’s to navigate clinical decisions better.
              </p>
            </div>
          </div>
        </div>

        <SectionCta headline="Work from the pathways Dr. Karito built for real consultations." label="Get the Decision Desk™" variant="gold" data-id="element-15" data-mp="2xggt0q9z02ki" />
      </div>
    </section>;
}